// @flow

import React from 'react';
import PropTypes from 'prop-types';

import Collapsible from '../../../components/collapsible';

import { TitleContentCMS } from '../../../data/cms/types/common';

import './style.css';

type Props = {
    Content: Array<TitleContentCMS>
};

function FAQ(props: Props) {
    const { Content } = props;

    return <Collapsible data={Content} />;
}

FAQ.propTypes = {
    Content: PropTypes.array.isRequired
};

export default FAQ;
